import { Label } from "~/shadcn/ui/label"
import { copyMediaKitLink, publicMediaKitUrl } from "./mediaKitLink"
import { PublicMediaKitSwitch } from "./PublicMediaKitSwitch"

const SWITCH_ID = "agency.publicMediaKitEnabled"

// The agency's own "Public media kit" setting row (ZAN-902). While published,
// it shows the URL to share (ZAN-929).
export const PublicMediaKitSetting = ({
  agencyId,
  agencySlug,
  enabled,
}: {
  agencyId: string
  agencySlug: string
  enabled: boolean
}) => {
  const url = publicMediaKitUrl(agencySlug)

  return (
    <div className="flex flex-col gap-2 pt-4">
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-col gap-1">
          <Label
            htmlFor={SWITCH_ID}
            className="text-body3 text-gray80 font-normal"
          >
            Public media kit
          </Label>
          <p className="text-xs text-gray50">
            Anyone with the link can view your roster and each visible creator's
            media kit. Saves as soon as you switch it.
          </p>
        </div>
        <PublicMediaKitSwitch
          id={SWITCH_ID}
          agencyId={agencyId}
          variant={{ kind: "own", agencySlug }}
          enabled={enabled}
        />
      </div>
      {enabled && (
        <div className="flex flex-row items-center gap-3 text-xs">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-gray80 underline"
          >
            {url}
          </a>
          {/* type="button": this row sits inside the account form. */}
          <button
            type="button"
            className="shrink-0 font-medium text-gray80 underline"
            onClick={() => copyMediaKitLink(url)}
          >
            Copy link
          </button>
        </div>
      )}
    </div>
  )
}
